const data = [
    { value: true, name: "Habilitada" },
    { value: false, name: "Desabilitada" },
]

export default [...data]